import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useDialog from "../../../hooks/useDialog";
import { defaultDatePickerStrings } from "@fluentui/react-datepicker-compat";
import { I18N_NS_DOCUMENTS, translationCommonOptions } from "../constants";
import moment from "moment";
import { toast } from "sonner";
import { downloadFile } from "../../../api/downloadFile";

const useLogicDialogExportHoursWorked = () => {
    // * STATES & CONTEXTS
    // * STATES & CONTEXTS
    // * STATES & CONTEXTS
    const { t } = useTranslation(I18N_NS_DOCUMENTS);
    const [selectedEmployeesDepartments, setSelectedEmployeesDepartments] =
        useState([]);
    const [monthYearFrom, setMonthYearFrom] = useState({
        startDate: null,
        endDate: null,
    });
    const [monthYearTo, setMonthYearTo] = useState({
        startDate: null,
        endDate: null,
    });
    const [downloadingExcel, setDownloadingExcel] = useState(false);
    const [open, _, openDialog, closeDialog] = useDialog();

    // * ASSIGN
    // * ASSIGN
    // * ASSIGN
    const isValidForm =
        !!monthYearFrom.startDate &&
        !!monthYearFrom.endDate &&
        !!monthYearTo.startDate &&
        !!monthYearTo.endDate;
    const localizedStrings = useMemo(
        () => ({
            ...defaultDatePickerStrings,
            days: t("temporal.days", translationCommonOptions),
            shortDays: t("temporal.shortDays", translationCommonOptions),
            months: t("temporal.months", translationCommonOptions),
            shortMonths: t("temporal.shortMonths", translationCommonOptions),
            goToToday: t("temporal.goToToday", translationCommonOptions),
        }),
        [t]
    );

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const beforeCloseDialog = () => {
        resetStates();
        closeDialog();
        return;
    };
    const resetStates = () => {
        setMonthYearFrom({
            startDate: null,
            endDate: null,
        });
        setMonthYearTo({
            startDate: null,
            endDate: null,
        });
        setSelectedEmployeesDepartments([]);
        return;
    };
    const onFormatDate = (date) => {
        if (date) {
            return `${
                localizedStrings.months[date.getMonth()]
            } ${date.getFullYear()}`;
        }
        return "";
    };
    const onSelectDate = (date) => {
        if (date) {
            const startDate = moment(date).startOf("month");
            const endDate = moment(date).endOf("month");
            setMonthYearFrom({
                startDate: startDate.format("YYYY-MM-DD"),
                endDate: endDate.format("YYYY-MM-DD"),
            });
        }
    };
    const onSelectDateTo = (date) => {
        if (date) {
            const startDate = moment(date).startOf("month");
            const endDate = moment(date).endOf("month");
            setMonthYearTo({
                startDate: startDate.format("YYYY-MM-DD"),
                endDate: endDate.format("YYYY-MM-DD"),
            });
        }
    };
    const onChangeUsersDepartments = (e, i) => {
        setSelectedEmployeesDepartments(i.value);
    };
    const downloadExcel = async () => {
        if (
            !monthYearFrom.startDate ||
            !monthYearFrom.endDate ||
            !monthYearTo.startDate ||
            !monthYearTo.endDate
        ) {
            toast.error("Veuillez sélectionner un mois et une année.", {
                position: "bottom-right",
            });
            return;
        }
        setDownloadingExcel(true);
        const url = `/time_reporting/hr/export-ocirt?start_date=${monthYearFrom.startDate}&end_date=${monthYearTo.endDate}`;
        const urlParamsUd = selectedEmployeesDepartments
            .map((d) => `&ud=${d.key}`)
            .join("");
        const result = await downloadFile({
            url: `${url}${urlParamsUd}`,
        });

        if (!result.success) {
            toast.error(
                result.message ||
                    "Une erreur est survenue lors du téléchargement.",
                {
                    position: "bottom-right",
                }
            );
        }
        beforeCloseDialog();
        setDownloadingExcel(false);
        toast.success(
            `Le fichier "${result.filename}" a été téléchargé avec succès.`,
            {
                position: "bottom-right",
            }
        );
    };

    return {
        translations: {
            t,
            localizedStrings,
        },
        dialog: {
            open,
            openDialog,
        },
        functions: {
            onFormatDate,
            onSelectDate,
            onSelectDateTo,
            onChangeUsersDepartments,
            downloadExcel,
            beforeCloseDialog,
        },
        form: {
            isValid: isValidForm,
            isDownloading: downloadingExcel,
            from: {
                value: monthYearFrom.startDate
                    ? new Date(monthYearFrom.startDate)
                    : null,
            },
            to: {
                value: monthYearTo.startDate
                    ? new Date(monthYearTo.startDate)
                    : null,
            },
        },
    };
};

export default useLogicDialogExportHoursWorked;
